import React from 'react';
import Authenticator from 'pages/Authenticator';
import UnauthAccess from 'pages/UnauthAccess';
import { Route } from 'react-router-dom';
import { RootPageLayout } from 'components/threepp/LayoutLoader/RootPageLayout/RootPageLayout';

export const ProtectedRoute = ({ exact, path, authenticated, component }) =>
  authenticated ? (
    <Authenticator>
      <RootPageLayout>
        <Route exact={exact} path={path} component={component} />
      </RootPageLayout>
    </Authenticator>
  ) : (
    <UnauthAccess>
      <RootPageLayout>
        <Route exact={exact} path={path} component={component} />
      </RootPageLayout>
    </UnauthAccess>
  );
